import React from "react";
import { Container } from "react-bootstrap";
import { BOOKINGS, SHOP } from "../data/shop";
import { Contact } from "./Contact";
import { Copyright } from "./Copyright";
import { Hours } from "./Hours";
import { Zia } from "./Zia";
import "./Footer.css";

export const Footer = () => (
  <footer id="visit" className="footer">
    <Container>
      <div className="footer__grid">
        <div className="footer-block footer__brand">
          <img
            src="/assets/randysbarbershop.png"
            alt="Randy's Old Fashioned Barber Shop"
          />
          <p className="script">{SHOP.tagline}</p>
          <div className="footer__book">
            {BOOKINGS.map((booking, index) => (
              <a
                key={booking.url}
                className={index === 0 ? "btn-shop" : "btn-ghost"}
                href={booking.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Book with {booking.barber}
              </a>
            ))}
          </div>
        </div>

        <Hours />
        <Contact />
      </div>

      <div className="footer__rule">
        <Zia size={20} />
      </div>

      <Copyright />
    </Container>
  </footer>
);
